import React from 'react'

import { BaseView, BaseText } from '@/components'
import { CurrencyAvatar } from '@/components/CurrencyAvatar'
import { ChevronRight } from '@/assets/icons'
import { useTheme } from '@/hooks/useTheme'
import { WalletCurrency } from '@/domain/wallet'
import { getDisplayCurrencyCode } from '@/utils/getDisplayCurrencyCode'

export interface CurrencyItemProps extends WalletCurrency {
  onPress: (currency?: WalletCurrency) => void
}

export const CurrencyItem: React.FC<CurrencyItemProps> = (props) => {
  const { name, displayCurrencyCode, icon, avatarBGRefColor, onPress } = props

  const theme = useTheme()

  const handlePress = () => {
    onPress(props)
  }

  return (
    <BaseView
      row
      align="center"
      gap={12}
      p={12}
      pl={12}
      pr={12}
      pt={14}
      pb={14}
      rounded={28}
      style={{
        backgroundColor: theme.colors.background.cardItemRoot,
        cursor: 'pointer',
        transition: 'all 0.2s ease',
      }}
      className="hover:opacity-80"
      onClick={handlePress}
    >
      {/* Currency Icon - as in RN Avatar with isCurrency=true */}
      <CurrencyAvatar
        uri={icon}
        bgColor={avatarBGRefColor}
        size={48}
        iconSize={26}
        fallbackText={displayCurrencyCode?.substring(0, 2) || '?'}
      />

      {/* Currency Info */}
      <BaseView flex={1} gap={2}>
        <BaseText fontSize={16} fontFamily="bold" color="label.default">
          {name}
        </BaseText>
        <BaseText fontSize={16} fontFamily="semibold" color="label.description">
          {getDisplayCurrencyCode(displayCurrencyCode || '')}
        </BaseText>
      </BaseView>

      {/* Chevron Right */}
      <ChevronRight size={38} color="#666666" />
    </BaseView>
  )
}
